module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("FOREWORD")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("O")]), _vm._v("ver the past 40 years, I have taught and lectured on success and achievement to more than 5 million people in 83 countries. I have always searched for the answer to the key question: "), _c('em', [_vm._v("Why are some people more successful than others?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now, Rob Jolles, a talented and skilled author, teacher, and success coach, has identified one of the most important reasons for success and failure, happiness and unhappiness, ever discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Based on his many years of working with thousands of people, he shows you exactly what you need to do to become the master of your life, to achieve your goals, and to break through any barriers (mostly mental) that might be holding you back.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rob has invested hundreds of hours in study and teaching to conclude that your believability, credibility, and authenticity are the most important qualities you can develop to get people to trust you from the first moment of meeting.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("He teaches that there is a direct relationship between how much you trust and believe in yourself and how much others trust and believe in you.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You learn a series of practical, proven techniques and actions that you can practice to be more believable and influential with each person you meet. You learn how to get and keep the job you really want and how to be seen as a leader in your work and personal life.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I was growing up, coming from a poor and dysfunctional family, I never had any friends, at least not for very long. I spent most of my childhood alone or in the company of other unpopular kids. It never occurred to me that all personality skills are learnable, that by treating people in a certain way, they will trust and believe you from the first eye contact.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Interviews with personnel executives—those who do the hiring for large and small companies—found that their decision whether to hire someone was made largely in the first 30 seconds—from the first greeting, handshake, and response.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sometimes I ask my audiences, “How much of decision-making is logical and how much is emotional?” They usually guess that the ratio is 80-to-20 or 90-to-10. I then explain to them that in truth it is 100 percent emotional. We decide emotionally and then we justify logically. Rob shows you how to immediately connect with people at a deep level emotionally and then move to logic and reason.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("As a professional speaker, I must connect with my audience—often hundreds or thousands people—within the first 30 seconds and then maintain that connection for several hours, right up to the conclusion of the event. You can do the same with the people you meet.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The good news is that all relationship and personality skills are learnable with practice and repetition. You can learn any skill you need to improve the quality of your life. There are no limits.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Congratulations to you for reading this book. It can change your life forever.")])]), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('strong', [_vm._v("Brian Tracy")]), _c('br'), _vm._v("Motivational public speaker"), _c('br'), _vm._v("and self-development author")]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4203ab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 75
// module chunks = 0